import { Box } from '@mui/material';
import type React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  catalogTemplate: {
    '&&.contentWrapper': {
      flex: 1,
      position: 'relative',
      background: `linear-gradient(180deg,
        ${theme.new.color.brand[100]} 0%,
        ${theme.new.color.brand[100]} 20%,
        ${theme.new.color.common.white} 33%,
        ${theme.new.color.common.white} 100%
      )`,
      width: '100%',
      height: '100%',
      paddingTop: theme.new.spacing.xl,
      paddingBlockEnd: theme.new.spacing.xl,
      [theme.breakpoints.up('md')]: {
        paddingTop: `calc(${theme.new.spacing.xl} * 2)`,
        paddingBlockEnd: `calc(${theme.new.spacing.xl} * 2)`,
      },
    },
  },
}));

const CatalogTemplate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { classes } = useStyles();
  return (
    <Box
      className={`contentWrapper ${classes.catalogTemplate}`}
      data-testid="catalog-template"
    >
      {children}
    </Box>
  );
};

export default CatalogTemplate;
